import React, { Component } from 'react'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { changeActiveSlide } from '../actions'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import './Menu.css'

class Menu extends Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
        this.toggleDrawer = this.toggleDrawer.bind(this)
    }

    toggleDrawer() {
        this.setState({ open: !this.state.open })
    }



    render() { 

        const nodes = this.props.drawerItems.map(item => (
            <ListItem button onClick={() => {
                this.props.changeActiveSlide(item.slide)
                this.toggleDrawer()
            }}>{item.text}</ListItem>
        ))

        return (
            <React.Fragment>
                <i className="Menu-Bar fas fa-bars" onClick={this.toggleDrawer}></i>
                <SwipeableDrawer open={this.state.open} onClose={this.toggleDrawer} onOpen={this.toggleDrawer}>
                    <List>
                    { nodes }
                    </List>
                </SwipeableDrawer>
            </React.Fragment>
        )
    }
}

Menu.propTypes = {
    drawerItems: PropTypes.array.isRequired
}
 
export default connect(({ drawerItems }) => ({ drawerItems }), dispatch => ({
    changeActiveSlide(slide) {
        dispatch(changeActiveSlide(slide))
    }
}))(Menu);


// WEBPACK FOOTER //
// ./src/components/Menu.js